import React from 'react';
import DeleteIcon from 'src/assets/images/Menu/DeleteIcon.svg';

const DeleteButtonCell = ({
    item,
    index,
    isSubItem,
    isEquityTemplate,
    isEquityPage,
    isQuickOrder,
    isQuickOrderEquityTemplate,
    isItemBundlePopup,
    deleteProduct,
    productKeyBundle
}) => {
    return (
        <div
            className={
                item.isPlaceHolderAdded ||
                    item.isDeleteButtonPresent ===
                    false
                    ? 'disabled'
                    : ''
            }
            style={{
                width: '25px',
                height: '29px',
                display:
                    'flex',
                justifyContent:
                    'center',
                alignItems:
                    'center',
                border: 'unset',
                boxShadow:
                    '0px 0px 2px #00000029',
                borderRadius:
                    '6px',
                opacity:
                    '1',
                visibility:
                    item.isDeleteButtonPresent ===
                        false
                        ? 'hidden'
                        : '',
            }}
        >
            <img
                src={
                    DeleteIcon
                }
                alt={
                    'delete'
                }
                id={`item-delete-icon-${item.productCFN || item.cfn || item.bom || index}`}
                onClick={() =>
                    isSubItem
                        ? isEquityTemplate
                            ? deleteProduct(
                                item,
                                'Bundle',
                                productKeyBundle
                            )
                            : ((isEquityPage && isQuickOrder) || (isQuickOrder && isQuickOrderEquityTemplate)) ? deleteProduct(item, 'isBundle')
                                : deleteProduct(
                                    productKeyBundle,
                                    item.productKey
                                )
                        : isItemBundlePopup
                            ? deleteProduct(
                                item.productKey
                            )
                            : deleteProduct(
                                item
                            )
                }
                style={{
                    cursor: 'pointer',
                }}
            />
        </div>
    );
};

export default DeleteButtonCell;